import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { TeamBLayout } from '@/components/TeamBLayout';
import { TeamBHome } from '@/pages/team-b/TeamBHome';
import { TeamBAddPlant } from '@/pages/team-b/TeamBAddPlant';
import { TeamBDailyObservation } from '@/pages/team-b/TeamBDailyObservation';
import { TeamBCareAdvice } from '@/pages/team-b/TeamBCareAdvice';
import { TeamBCareReminder } from '@/pages/team-b/TeamBCareReminder';
import { TeamBGrowthTimeline } from '@/pages/team-b/TeamBGrowthTimeline';
import { TeamBStageReport } from '@/pages/team-b/TeamBStageReport';

function withLayout(Page: React.ComponentType) {
  return function Wrapped() {
    return (
      <TeamBLayout>
        <Page />
      </TeamBLayout>
    );
  };
}

const Home = withLayout(TeamBHome);
const AddPlant = withLayout(TeamBAddPlant);
const Daily = withLayout(TeamBDailyObservation);
const Advice = withLayout(TeamBCareAdvice);
const Reminder = withLayout(TeamBCareReminder);
const Timeline = withLayout(TeamBGrowthTimeline);
const Report = withLayout(TeamBStageReport);

/** 兼容旧路径 /health、/diary,保留 query 参数 */
function LegacyRedirect({ to }: { to: string }) {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}`} replace />;
}

export default function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/add" element={<AddPlant />} />
        <Route path="/daily" element={<Daily />} />
        <Route path="/advice" element={<Advice />} />
        <Route path="/reminder" element={<Reminder />} />
        <Route path="/timeline" element={<Timeline />} />
        <Route path="/report" element={<Report />} />
        <Route path="/health" element={<LegacyRedirect to="/advice" />} />
        <Route path="/diary" element={<LegacyRedirect to="/timeline" />} />
        <Route path="/b/*" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ErrorBoundary>
  );
}
